export default __webpack_public_path__ + "static/media/CBBG.5d383e37.jpg";